import React, { useEffect } from "react";
import { useLocation, Link } from "react-router-dom";
import { Container, Nav, Navbar, NavDropdown, Button } from "react-bootstrap";
import logo from "../Assets/Images/logo-black.png";
import logowhite from "../Assets/Images/logo.png";
import { useState } from "react";

function NavBar({ currenttheme, settheme }) {
  const location = useLocation();
  const [activePath, setActivePath] = useState(location.pathname);

  const isActive = (path) => {
    return activePath === path ? "active" : "";
  };

  const handleChange = () => {
    if (currenttheme === "Darktheme") {
      settheme("LightTheme");
      localStorage.setItem("Theme", "LightTheme");
    } else {
      localStorage.setItem("Theme", "Darktheme");
      settheme("Darktheme");
    }
  };
  useEffect(() => {
    setActivePath(location.pathname);
  }, [location.pathname]);

  return (
    <>
      <Navbar expand="lg">
        <Container>
          <Navbar.Brand
            as={Link}
            to="/"
            className={isActive("/")}
            onClick={() => {
              setActivePath("/");
            }}
          >
            <img className="dark-logo" src={logo} alt="Logo" />
            <img className="light-logo" src={logowhite} alt="Logo" />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
              <Nav.Link
                as={Link}
                to="/"
                className={isActive("/")}
                onClick={() => {
                  setActivePath("/");
                }}
              >
                Home
              </Nav.Link>

              <NavDropdown title="Tokens" id="basic-nav-dropdown">
                <NavDropdown.Item
                  as={Link}
                  to="/TopTokens"
                  className={isActive("/TopTokens")}
                  onClick={() => {
                    setActivePath("/TopTokens");
                  }}
                >
                  ERC 20 TopTokens
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  to="/TokenTransfer"
                  className={isActive("/TokenTransfer")}
                  onClick={() => {
                    setActivePath("/TokenTransfer");
                  }}
                >
                  View ERC20 Transfer
                </NavDropdown.Item>
                <NavDropdown.Divider />
              </NavDropdown>
              <Nav.Link
                as={Link}
                to="/blocks"
                className={isActive("/blocks")}
                onClick={() => {
                  setActivePath("/blocks");
                }}
              >
                Blocks
              </Nav.Link>
              <Nav.Link
                as={Link}
                to="/txs"
                className={isActive("/txs")}
                onClick={() => {
                  setActivePath("/txs");
                }}
              >
                Transactions
              </Nav.Link>
              {/* <NavDropdown title="Resources" id="basic-nav-dropdown">
                <NavDropdown.Item
                  as={Link}
                  to="/VerfiedContracts"
                  className={isActive("/VerfiedContracts")}
                  onClick={() => setActivePath("/VerfiedContracts")}
                >
                  Verified Contracts
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  to="/RichList"
                  className={isActive("/RichList")}
                  onClick={() => setActivePath("/RichList")}
                >
                  Richlist
                </NavDropdown.Item>
              </NavDropdown>
              <NavDropdown title="More" id="basic-nav-dropdown">
                <NavDropdown.Item as={Link} to="#action/3.1">
                  Unit Converters
                </NavDropdown.Item>
              </NavDropdown> */}
              <Button className="theme-btn" onClick={handleChange}>
                <i className="fa fa-sun-o"></i>
                <i className="fa fa-moon-o"></i>
              </Button>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
}

export default NavBar;
